exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.caz-image[data-v-66b9d312]{position:relative;width:100%;height:100%;-o-object-fit:cover;object-fit:cover;margin-top:-20px;z-index:-1\n}\n@media (min-width: 768px){\n.caz-image[data-v-66b9d312]{margin-top:0\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66b9d312","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/cms-content-slices/components/clean-air-zone/BannerImage.vue
// module id = FYgB
// module chunks = 32